export default "__VITE_PUBLIC_ASSET__e6554d13__"